import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app-config.loader';
import { Utente } from '../shared/models/utente.model';
import { AnagraficaBaseService } from './anagrafica-base.service';

@Injectable({
  providedIn: 'root'
})
export class AnagraficaUtentiService extends AnagraficaBaseService<Utente> {
  constructor(appConfig: AppConfig, http: HttpClient) {
    super(http, `${appConfig.settings.apiRoot}/AnagraficaUtenti`);
  }

  get idProperty(): string {
    return 'utenteId';
  }

  get nameProperty(): string {
    return 'nomeUtente';
  }
}
